import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ConnectorController, CoreHelperUtil } from '@web3modal/core';
import { customElement } from '@web3modal/ui';
import { LitElement, html } from 'lit';
import { state } from 'lit/decorators.js';
import { ref, createRef } from 'lit/directives/ref.js';
import styles from './styles.js';
import { SnackController, RouterController, EventsController } from '@web3modal/core';
let W3mEmailLoginWidget = class W3mEmailLoginWidget extends LitElement {
  constructor() {
    super();
    this.unsubscribe = [];
    this.formRef = createRef();
    this.connectors = ConnectorController.state.connectors;
    this.email = '';
    this.loading = false;
    this.error = '';
    this.unsubscribe.push(ConnectorController.subscribeKey('connectors', val => this.connectors = val));
  }
  disconnectedCallback() {
    this.unsubscribe.forEach(unsubscribe => unsubscribe());
  }
  firstUpdated() {
    var _this$formRef$value;
    (_this$formRef$value = this.formRef.value) === null || _this$formRef$value === void 0 || _this$formRef$value.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        this.onSubmitEmail(event);
      }
    });
  }
  render() {
    const multipleConnectors = this.connectors.length > 1;
    const connector = this.connectors.find(c => c.type === 'EMAIL');
    if (!connector) {
      return null;
    }
    return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      ", "\n      <form ", " @submit=", ">\n        <wui-email-input\n          @focus=", "\n          .disabled=", "\n          @inputChange=", "\n          .errorMessage=", "\n        >\n        </wui-email-input>\n\n        ", "", "\n        <input type=\"submit\" hidden />\n      </form>\n\n      ", "\n    "])), this.alphaWarningTemplate(), ref(this.formRef), this.onSubmitEmail.bind(this), this.onFocusEvent.bind(this), this.loading, this.onEmailInputChange.bind(this), this.error, this.submitButtonTemplate(), this.loadingTemplate(), multipleConnectors ? html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<wui-separator text=\"or\"></wui-separator>"]))) : null);
  }
  alphaWarningTemplate() {
    const showAlphaWarning = true;
    return showAlphaWarning ? html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          <wui-flex class=\"alphaBanner\" gap=\"xs\" alignItems=\"center\" justifyContent=\"center\">\n            <wui-icon-box\n              size=\"sm\"\n              icon=\"alpha\"\n              iconColor=\"accent-100\"\n              background=\"opaque\"\n              backgroundColor=\"accent-100\"\n            ></wui-icon-box>\n            <wui-text variant=\"small-400\" color=\"accent-100\">\n              This is an alpha version to test before launch\n            </wui-text>\n          </wui-flex>\n        "]))) : null;
  }
  submitButtonTemplate() {
    const showSubmit = !this.loading && this.email.length > 3;
    return showSubmit ? html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          <wui-icon-link\n            size=\"sm\"\n            icon=\"chevronRight\"\n            iconcolor=\"accent-100\"\n            @click=", "\n          >\n          </wui-icon-link>\n        "])), this.onSubmitEmail.bind(this)) : null;
  }
  loadingTemplate() {
    return this.loading ? html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<wui-loading-spinner size=\"md\" color=\"accent-100\"></wui-loading-spinner>"]))) : null;
  }
  onEmailInputChange(event) {
    this.email = event.detail;
    this.error = '';
  }
  async onSubmitEmail(event) {
    try {
      if (this.loading) {
        return;
      }
      this.loading = true;
      event.preventDefault();
      const emailConnector = ConnectorController.getEmailConnector();
      if (!emailConnector) {
        throw new Error('w3m-email-login-widget: Email connector not found');
      }
      const {
        action
      } = await emailConnector.provider.connectEmail({
        email: this.email
      });
      EventsController.sendEvent({
        type: 'track',
        event: 'EMAIL_SUBMITTED'
      });
      if (action === 'VERIFY_OTP') {
        EventsController.sendEvent({
          type: 'track',
          event: 'EMAIL_VERIFICATION_CODE_SENT'
        });
        RouterController.push('EmailVerifyOtp', {
          email: this.email
        });
      } else if (action === 'VERIFY_DEVICE') {
        RouterController.push('EmailVerifyDevice', {
          email: this.email
        });
      }
    } catch (error) {
      const parsedError = CoreHelperUtil.parseError(error);
      if (parsedError !== null && parsedError !== void 0 && parsedError.includes('Invalid email')) {
        this.error = 'Invalid email. Try again.';
      } else {
        SnackController.showError(error);
      }
    } finally {
      this.loading = false;
    }
  }
  onFocusEvent() {
    EventsController.sendEvent({
      type: 'track',
      event: 'EMAIL_LOGIN_SELECTED'
    });
  }
};
W3mEmailLoginWidget.styles = styles;
__decorate([state()], W3mEmailLoginWidget.prototype, "connectors", void 0);
__decorate([state()], W3mEmailLoginWidget.prototype, "email", void 0);
__decorate([state()], W3mEmailLoginWidget.prototype, "loading", void 0);
__decorate([state()], W3mEmailLoginWidget.prototype, "error", void 0);
W3mEmailLoginWidget = __decorate([customElement('w3m-email-login-widget')], W3mEmailLoginWidget);
export { W3mEmailLoginWidget };
//# sourceMappingURL=index.js.map